define(['app/modules/forms'], function(Forms) {
  var Hiring_teams = function () {};

  Hiring_teams.prototype.actionShow = function() {
    $('.add-member').on('click', function(e) {
      $('#invite-form .form-group:first .chosen-container').css('margin-right', '36px');
      e.preventDefault();
      var form = $('#invite-form');
      var inputs = form.find('.form-group:first').clone();
      inputs.find('input').val('');
      inputs.find('.chosen-container').remove();
      inputs.insertBefore($('form .form-actions'));

      var select = form.find('.form-group:last select');
      select.val(0);
      $('<i class="fa fa-times remove-member"></i>').insertAfter(select);
      select.chosen({
        disable_search_threshold: 10,
        width: "100%",
        allow_single_deselect: true
      });

      $('.section-invite-member .invite-member').show();
    });

    $('body').on('click', '.remove-member', function() {
      $(this).parent().remove();
      if ($('#invite-form .form-group .chosen-container').length < 2) {
        $('#invite-form .form-group:first .chosen-container').css('margin-right', '0px');
      }
    });

    $('.filter select').change(function(e){
      var newValue = $(this).val();
      $('.table tr').each(function() {
        if ($(this).hasClass(newValue)) {
          $(this).addClass('visible');
        } else {
          $(this).removeClass('visible');
        }
      });
      if (newValue == 'Deactivated') {
        $('.icon-btn').hide();
      } else {
        $('.batch-activate-members').hide();
      }
      if ($('table .icheckbox.checked:visible').length > 0) {
        if (newValue == 'Deactivated') {
          $('.batch-activate-members').show();
        } else {
          $('.icon-btn').show();
        }
      } else {
        if (newValue == 'Deactivated') {
          $('.batch-activate-members').hide();
        } else {
          $('.icon-btn').hide();
        }
      }
    });

    $('.checkbox-icheck').on('ifChecked', function() {
      setTimeout(function() {
        var filter_value = $('.filter select').val();
        if ($('table .icheckbox.checked:visible').length > 0) {
          if (filter_value == 'Deactivated') {
            $('.batch-activate-members').show();
            $('.icon-btn').hide();
          } else {
            $('.icon-btn').show();
            $('.batch-activate-members').hide();
          }
        }
      }, 100);
    });

    $('.checkbox-icheck').on('ifUnchecked', function() {
      setTimeout(function() {
        var filter_value = $('.filter select').val();
        if ($('table .icheckbox.checked:visible').length == 0) {
          if (filter_value == 'Deactivated') {
            $('.batch-activate-members').hide();
          } else {
            $('.icon-btn').hide();
          }
        }
      }, 100);
    });

    $('.check-all').on('ifChecked', function() {
      $('table .checkbox-icheck:visible').iCheck('check');
    });

    $('.check-all').on('ifUnchecked', function() {
      $('table .checkbox-icheck:visible').iCheck('uncheck');
    });

    $('.delete-member i').on('click', function() {
      var target = $(this).parents('tr');
      var param = {};
      param[target.find('input').attr('name').slice(0, -2)] = [target.find('input').attr('value')];

      $.ajax({
        type: 'DELETE',
        data: param,
        url: '/preferences/hiring_teams',
        dataType: "json",
        success: function(result){
          if(result.status == 'ok'){
            document.location.reload();
          }
        }
      });
    });

    var activate_members = function(param) {
      $.ajax({
        type: 'PUT',
        data: param,
        url: '/preferences/hiring_teams/activate',
        dataType: "json",
        success: function(result){
          if(result.status == 'ok') {
            document.location.reload();
          }
        }
      });
    };

    $('.activate-member i').on('click', function() {
      var target = $(this).parents('tr');
      var param = {};
      param['user_ids'] = [target.find('input').attr('value')];
      activate_members(param);
    });

    $('.batch-activate-members').on('click', function() {
      var param = {};
      param['user_ids'] = [];

      $('table .icheckbox.checked:visible').each(function() {
        param['user_ids'].push($(this).find('input').val());
      });

      activate_members(param);
    });

    $('#invite-form').on('submit', function(e){
      e.preventDefault();
      Forms.submit($(this), '', function(){document.location.reload()});
    });

    $('.dropdown-menu li').on('click', function() {
      var parent = $(this).parent().parent();
      var newText = $(this).text();
      var permission_id = $(this).data('permission_id');

      var param = {};
      param.user_id = parent.parent().parent().find('input').val();
      param.permission = permission_id;
      $.ajax({
        type: 'PUT',
        data: param,
        url: '/preferences/hiring_teams',
        dataType: "json",
        success: function(result) {
          if(result.status == 'ok') {
            parent.find('.user-role').html(newText);
          }
        }
      });
    });
  };

  return Hiring_teams;
});
